import React from 'react';

import { getCalculatedBrightnessFromHex, useGetPaletteColors } from 'return-portal-ui';
import { twMerge } from 'tailwind-merge';

type CardProps = {
  children: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
  hasBottomBorder?: boolean;
  mobileOnly?: boolean;
};

const Card = ({
  children,
  mobileOnly,
  className,
  wrapperClassName,
  hasBottomBorder = true,
}: CardProps) => {
  const { secondaryBg } = useGetPaletteColors();

  const borderColor = getCalculatedBrightnessFromHex(secondaryBg, 2);

  return (
    <>
      <div className="hidden md:block w-full">
        <Wrapper mobileOnly={mobileOnly} className={wrapperClassName} secondaryBg={secondaryBg}>
          <Content
            className={className}
            borderColor={borderColor}
            hasBottomBorder={hasBottomBorder}
            secondaryBg={secondaryBg}
            mobileOnly={mobileOnly}
          >
            {children}
          </Content>
        </Wrapper>
      </div>

      <div className="block md:hidden w-full">
        <Content
          secondaryBg={secondaryBg}
          className={className}
          borderColor={borderColor}
          hasBottomBorder={hasBottomBorder}
          mobileOnly={mobileOnly}
        >
          {children}
        </Content>
      </div>
    </>
  );
};

const Wrapper = ({
  children,
  secondaryBg,
  className,
  mobileOnly,
}: {
  children: React.ReactNode;
  secondaryBg: string;
  className?: string;
  mobileOnly?: boolean;
}) => (
  <div
    className={twMerge(
      'md:px-[1px] md:py-[1px] md:rounded-[15px] w-full h-fit',
      mobileOnly && 'md:px-0 px-0',
      className,
    )}
    style={{ backgroundColor: `${secondaryBg}4D` }}
  >
    {children}
  </div>
);

const Content = ({
  children,
  className,
  borderColor,
  hasBottomBorder,
  secondaryBg,
  mobileOnly = false,
}: {
  children: React.ReactNode;
  className?: string;
  borderColor: string;
  hasBottomBorder: boolean;
  secondaryBg: string;
  mobileOnly?: boolean;
}) => (
  <div
    style={{ borderColor: borderColor, backgroundColor: secondaryBg }}
    className={twMerge(
      'flex w-full relative md:rounded-[14px] ',
      hasBottomBorder ? 'border-b md:border-none' : '',
      mobileOnly && '!rounded-[0px]',
      className,
    )}
  >
    {children}
  </div>
);

export default Card;
